import {
  Button,
  Col,
  Image,
  Modal,
  Row,
  Divider,
  Steps,
  Card,
  Table,
  Select,
  DatePicker,
} from "antd";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import notfound from "../assets/images/not_found.png";
import apiPath from "../constants/apiPath";
import { Severty, ShowToast } from "../helper/toast";
import useRequest from "../hooks/useRequest";
import { ChangeLogAction, capitalize } from "../helper/functions";
import lang from "../helper/langHelper";
import { useParams } from "react-router";
import { AppStateContext } from "../context/AppContext";
import useDebounce from "../hooks/useDebounce";
import SectionWrapper from "../components/SectionWrapper";
import { UndoOutlined } from "@ant-design/icons";
import { method } from "lodash";

export const ApproveStatus = {
  REJECT: "rejected",
  ACCEPT: "accepted",
  SUSPENDED: "suspended",
  PENDING: "pending",
};

const ViewLogs = ({ show, hide, data }) => {
  const { setPageHeading, country } = useContext(AppStateContext);

  const { request } = useRequest();
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [logs, setLogs] = useState([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [refresh, setRefresh] = useState(false);
  const [filter, setFilter] = useState({user_id : params.id ? params.id : undefined});
  const [subAdmin, setSubAdmin] = useState([]);

  const columns = [
    {
      title: "Sub Admin Name",
      dataIndex: "user_id",
      key: "user_id",
      sorter: (a, b) => a?.user_id?.name?.localeCompare(b?.user_id?.name),
      sortDirections: ["ascend", "descend"],
      render: (_, { user_id }) => {
        return user_id?.name ? (
          <span className="cap">{user_id?.name}</span>
        ) : (
          "-"
        );
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, { action, created_at }) => {
        return action ? (
          <span className="cap">{`${capitalize(action)} on ${moment(
            created_at
          ).format("ll")}`}</span>
        ) : (
          "-"
        );
      },
    },
    {
      title: "Message",
      dataIndex: "message",
      key: "message",
      render: (_, { action, created_at, message }) => {
        return message ? <span className="cap">{message}</span> : "-";
      },
    },
  ];

  const handleChange = (pagination, filters, sorter) => {
    const { field, order } = sorter;
    let query = undefined;
    if (field && order) {
      query = `${field}=${order}`;
      console.log(query);
    }
    fetchData(pagination, filters, query);
  };

  const fetchData = (pagination, filters, sorter) => {
    const filterActive = filters ? filters.is_active : null;
    const queryString = Object.entries(filter)
      .filter(([_, v]) => v != undefined)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");
    request({
      url:
        `${apiPath.log}${params.id ? "/" + params.id : ""}` +
        `?status=${filterActive ? filterActive.join(",") : ""}&page=${
          pagination ? pagination.current : 1
        }&pageSize=${pagination ? pagination.pageSize : 10}${
          queryString ? `&${queryString}` : ""
        }`,
      method: "GET",
      onSuccess: ({ data, total }) => {
        setLoading(false);
        setLogs(data);
        setPagination((prev) => ({
          ...prev,
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: total,
        }));
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);

        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const fetchSubAdmin = ()=>{
    request({
      url : apiPath.common.subAdmin,
      method : "GET",
      onSuccess :(({data})=>{
         setSubAdmin(data?.data ?? [])
      }),
      onError :((err)=>{
        console.log(err)
      })
    })
  }

  useEffect(() => {
    setLoading(true);
    fetchData(pagination);
    fetchSubAdmin()
  }, [params, refresh, filter]);

  useEffect(() => {
    setPageHeading(`Activity Logs Management`);
  }, [setPageHeading]);

  const onChange = (key, value) => {
    setFilter((prev) => ({ ...prev, [key]: value }));
  };
  return (
    <>
      <SectionWrapper
        cardHeading={`All Logs`}
        extra={
          <>
            <div className="role-wrap">
              <Select
                last20Years
                width="110px"
                placeholder={"Action"}
                showSearch
                value={filter.action}
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                options={ChangeLogAction.map((item) => ({
                  value: item.value,
                  label: item?.name,
                }))}
                onChange={(value) => {
                  onChange("action", value);
                }}
              />
            </div>
            <div className="role-wrap">
              <Select
                last20Years
                width="110px"
                placeholder={"Sub-Admin"}
                showSearch
                value={filter.user_id}
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                options={subAdmin?.map((item) => ({
                  value: item._id,
                  label: item?.name,
                }))}
                onChange={(value) => {
                  onChange("user_id", value);
                }}
              />
            </div>
            <div className="role-wrap">
                        <DatePicker.RangePicker                      
                         placeholder={[("Start Date") , ("End Date")]}
                         disabledDate={(current) => {return current && current > moment().endOf('day'); }}
                          value={[
                            filter.start_date
                              ? moment(filter.start_date)
                              : undefined,
                            filter.end_date
                              ? moment(filter.end_date)
                              : undefined,
                          ]}
                          onChange={(value) => {
                            if (value) {
                              setFilter((prev) => ({
                                ...prev,
                                start_date: moment(value[0]).format(
                                  "YYYY-MM-DD"
                                ),
                                end_date: moment(value[1]).format("YYYY-MM-DD"),
                              }));
                            } else {
                              setFilter((prev) => ({
                                ...prev,
                                start_date: undefined,
                                end_date: undefined,
                              }));
                            }
                          }}
                        />
                      </div>
            <Button
                  onClick={() => {
                    setFilter({
                      action: undefined,
                      user_id : undefined,
                      start_date : undefined,
                      end_date : undefined
                    });                 
                  }}
                  type="primary"
                  icon={<UndoOutlined />}
                >
                  {lang("Reset")}
                </Button>
          </>
        }
      >
        <div className="table-responsive customPagination checkBoxSrNo">
          <Table
            loading={loading}
            columns={columns}
            dataSource={logs}
            pagination={{
              current: pagination?.current,
              defaultPageSize: 10,
              responsive: true,
              total: pagination.total,
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: ["10", "20", "30", "50"],
            }}
            onChange={handleChange}
            className="ant-border-space"
          />
        </div>
      </SectionWrapper>
      {/* <Card loading={loading}>
        <div className="new_driver_dtl">
          <Row gutter={24}>
            {userName ? <Col span={24}>
              <div className="sub-damin-client-profile">
                <p>{data?.type} Name:</p>
                <p className="font-bold">{userName ?? "-"}</p>
              </div>
            </Col> : "" }

           {userEmail ? <Col span={24}>
              <div className="sub-damin-client-profile">
                <p>Email Address:</p>
                <p className="font-bold">{userEmail ?? "-"}</p>
              </div>
            </Col> : ""}
           {!userName && !userEmail ? 
           <Col>
            <h3 className="logs0-heading">All Activities</h3>
            </Col> : ""}
          </Row>
        </div>
        <div
          className={`driver-personal-dtl ${
            logs.length > 0 ? "" : "text-center"
          }`}
        >
          <Divider />
          {logs.length > 0 ? (
            <Steps
              progressDot
              current={0}
              direction="vertical"
              items={logs.map((item) => ({
                title: `${capitalize(item.action)} on ${moment(
                  item.created_at
                ).format("ll")}`,
                description: item.message,
              }))}
            />
          ) : (
            <h5>No Logs Found!</h5>
          )}
        </div>
      </Card> */}
    </>
  );
};

export default ViewLogs;
